<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#FFF;height:100%">
        <v-card elevation="0">
            <v-card-title>
                Produtos
                <div class="flex-grow-1"></div>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar produtos"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-card-actions>
                <v-btn small :to="{name:'product_list_audio_filter_status', params:{status:'published'}}" color="green" outlined>
                    Publicados
                </v-btn>
                 <v-btn small :to="{name:'product_list_audio_filter_status', params:{status:'readytoupload'}}" color="red" outlined>
                    Prontos para Subir
                </v-btn>
                <v-btn small :to="{name:'product_list_audio_filter_status', params:{status:'underanalysis'}}" color="warning" outlined>
                    Em análise
                </v-btn>
                <v-btn small :to="{name:'product_list_audio_filter_status', params:{status:'editable'}}" color="pink" outlined>
                    Em edição
                </v-btn>
                <v-btn small :to="{name:'product_list_audio_filter_status', params:{status:'editable_upgrade'}}" color="pink" outlined>
                    Em upgrade
                </v-btn>
                <v-btn small :to="{name:'product_list_audio'}" color="primary" outlined>
                    Todos
                </v-btn>

            </v-card-actions>

            <v-data-table :headers="headers" :items="products" :search="search"
                :footer-props="{itemsPerPageOptions:[50,100,200]}"
            >
                <template v-slot:item.artist="{item}">
                    <span v-if="item.artist">{{item.artist.name}}</span>
                </template>

                <template v-slot:item.cover="{item}">
                    <v-img width="70px" v-if="item.thumbnail" :src="get_cover_url(item)" />
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-btn icon text :to="{name:'product_edit_audio',params:{id:item.id}}">
                       &nbsp;<v-icon small class="mr-2">edit</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            
        </v-card>
    </v-sheet>
</template>

<script>
import ProductService from "../../../../app/rest/products";

var productService = null;

export default {
    components: {},
    data: () => ({
        search: "",
        product_filter:{flavor:"audio",status:''},
        products: [],
        headers: [
            {
                text: "Capa",
                align: "left",
                sortable: false,
                value: "cover"
            },
            { text: "Nome", value: "name" },
            { text: "Artista principal", value: "artist_name" },
            { text: "UPC", value: "upc" },
            { text: "Data de lançamento", value: "release_date" },
            { text: "Data de Criação", value: "created_at" },
            { text: "Status", value: "status" },
            { text: "Ações", value: "actions" }
        ]
    }),
    mounted: function() {
        if(this.$route.params.status!=undefined){
            this.product_filter.status = this.$route.params.status;
        }
        this.load_products();
        console.log(this.$route)
    },
    watch: {
    $route(to, from) {
        if(to.params.status!=undefined){
            this.product_filter.status = to.params.status;
        }else{
            this.product_filter.status = '';
        }

        this.load_products();
    }
    },
    methods: {
        load_products(){
            this.$store.dispatch('loading');
            if(this.product_filter.status == ''){
                delete this.product_filter.status;
            }
            productService = ProductService.build();
            productService
                .get_all( this.product_filter )
                .then(e => {
                    this.process_return( e )
                })
                .catch(e => {
                    //tivemos um erro, adicionar um alerta
                })
                .finally(() => {
                    this.$store.dispatch('loading', false)
                });
        },
        process_return(e){
            if (e.status == "ok") {
                    
                    this.products = e.items.products.map( function(ee){
                        
                        if(ee.artist)
                            ee.artist_name = ee.artist.name;
                        else{
                            ee.artist_name = "nao definido";
                        }
                      
                        return JSON.parse(JSON.stringify(ee)); 
                    } );                    
            }
        },
        get_cover_url(item) {
        return (item.thumbnail.indexOf("googleapis")>=0) ? 
                    item.thumbnail : process.env.VUE_APP_BASE_URL + item.thumbnail;
            

            //return process.env.VUE_APP_BASE_URL + item.thumbnail;
        },
    
    }
};
</script>